import {
    ACCESS_TYPE,
    Prices,
    PromotionModel,
    PromotionOdrModel,
    PromotionsModel,
    REDUCTION_TYPE,
} from '@bytel/bytel-sales';

export class PromotionsModelWeb extends PromotionsModel {
    constructor(
        automatic: PromotionModel[],
        manual: PromotionModel[],
        incitation: PromotionModel[],
        coupon?: PromotionModel,
    ) {
        super(automatic, manual, incitation, coupon);
    }

    public hasDiscountPercent(): boolean {
        return !!this.getDiscountPercent();
    }

    public getDiscountPercent(): number {
        const promoAuto = this.automatic.filter(
            (promo) => !(promo instanceof PromotionOdrModel) && promo.reductionType !== REDUCTION_TYPE.FIX,
        );
        return promoAuto[0]?.amount || 0;
    }

    public hasDiscount(): boolean {
        return this.automatic.reduce((acc, promo) => acc + promo.amount, 0) > 0;
    }

    public getDiscountLabel(): string {
        const promoAuto = this.automatic.filter(
            (promo) => !(promo instanceof PromotionOdrModel) && promo.reductionType !== REDUCTION_TYPE.FIX,
        );
        return promoAuto[0]?.label || '';
    }

    public getPrices(
        basePrice: number,
        minPrice: number = 0,
        withIncitation: boolean = false,
        withOdr: boolean = false,
    ): Prices {
        return super.getPrices(basePrice, minPrice, withIncitation, withOdr);
    }

    public getPromotionsByAccessType(accessType: ACCESS_TYPE, withIncitation: boolean = false): PromotionModel[] {
        const promos = withIncitation ? this.incitation.concat(this.automatic) : this.automatic;
        return promos.filter((promo) => promo.accessTypes.includes(accessType));
    }

    public hasPromotionsWithAccessType(accessType: ACCESS_TYPE, withIncitation: boolean = false): boolean {
        const promosFiltered = this.getPromotionsByAccessType(accessType, withIncitation);
        return promosFiltered.length > 0;
    }

    public getPriceWithoutAccessTypePromo(price: number, accessType: ACCESS_TYPE): number {
        const promos = this.incitation.concat(this.automatic);
        const promosFiltered = promos.filter((promo) => promo.accessTypes.includes(accessType));

        return price + this.getPromotionsAmount(price, promosFiltered);
    }

    public getPriceWithAccessTypePromo(price: number, accessTypes: ACCESS_TYPE[]): number {
        const promos = this.incitation.concat(this.automatic);
        const filteredPromos = promos.filter((promo) =>
            accessTypes.some((accessType: ACCESS_TYPE) => promo.accessTypes.includes(accessType)),
        );

        return price - this.getPromotionsAmount(price, filteredPromos);
    }

    public getPromotionsAmount(price: number, promos: PromotionModel[]): number {
        return promos.reduce((acc, promotion) => acc + promotion.getAmount(price), 0);
    }

    public getPricesWithPromos(price: number, minPrice: number, withAccessTypes: ACCESS_TYPE[]): Prices {
        const prices = super.getPrices(price, minPrice, true, false);
        const accessTypes = [ACCESS_TYPE.CONVERGENCE, ACCESS_TYPE.PORTABILITE];
        let promosNow = [];
        let promosForever = [];
        const promos = this.incitation.concat(this.automatic);

        accessTypes.forEach((accessType: ACCESS_TYPE) => {
            if (!withAccessTypes.includes(accessType)) {
                promos.forEach((promo) => {
                    if (promo.accessTypes.includes(accessType)) {
                        if (!promo.duration) {
                            promosForever = promosForever.concat([promo]);
                        }
                        promosNow = promosNow.concat([promo]);
                    }
                });
            }
        });

        prices.final += this.getPromotionsAmount(0, promosNow);
        prices.forever += this.getPromotionsAmount(0, promosForever);

        if (prices.final.toFixed(2) === prices.forever.toFixed(2)) {
            prices.duration = 0;
        }

        return prices;
    }

    public getImmediateDiscount(): number {
        return this.getPromotionsAmount(0, this.automatic);
    }
}
